export class ConfirmEmailRequestModel {
    UserId: string;
    Token: string;
    IsConfirmedEmail: boolean;
}